import { loadLanguageAsync } from '@/i18n';
import store from '.';

/**
 * Prepair amount object
 * @param amounts number or object
 */
const getAmounts = (amounts: any): any => {
  if (typeof amounts == 'object') {
    const keys = Object.keys(amounts);
    if (typeof amounts[keys[0]] === 'number') {
      keys.forEach((key: string) => {
        amounts[key] = {
          id: amounts[key],
          price: null,
        };
      });
    }
    return amounts;
  }
  return {};
};

export default {
  data: {
    state: {
      data: {},
      loadingData: true,
    },
    mutations: {
      setData: (state: { data: any }, data: any) => {
        state.data = data;
      },

      setLoading: (state: { loadingData: boolean }, loadingData: boolean) => {
        state.loadingData = loadingData;
      },
    },
    getters: {
      getData: (state: { data: any }) => {
        return state.data;
      },

      getNote: (state: { data: any }) => {
        return state.data.addNotes ? state.data.addNotes : false;
      },

      getBaseProductsArray: (state: { data: any }) => {
        const baseProducts = state.data.baseProducts;
        if (!baseProducts) return [];

        let baseProductsArray: any[] = [];
        Object.keys(baseProducts).forEach((key: string) => {
          baseProductsArray.push(baseProducts[key]);
        });
        return baseProductsArray;
      },

      getLoading: (state: { loadingData: boolean }): boolean => {
        return state.loadingData;
      },
    },
    actions: {
      getData: async (context: { commit: any }) => {
        const setData = async (data: any) => {
          data.data.baseProducts = getAmounts(data.data.baseProducts);
          context.commit('setData', data.data);
          store.dispatch('getCoffeeList', data.data);
          await loadLanguageAsync(data.data.lang, {
            ...data.data.genSettings,
            ...data.data.trans,
          }).then(() => {
            context.commit('setLoading', false);
          });
        };

        (window as any).axios
          .get('/wp-content/themes/belly-child/generator_data.json')
          .then(setData)
          .catch(() => {
            (window as any).axios
              .get('/?page_id=1461')
              .then(setData)
              .catch(() => {
                context.commit('setLoading', false);
              });
          });
      },
    },
  },
};
